var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"300px","height":"300px"}},[(_vm.wxQrCodeImg)?_c('img',{attrs:{"src":_vm.wxQrCodeImg,"width":"300","height":"300"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }